import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ConfigurationComponent } from '../components/configuration/configuration.component';

@Component({
  selector: 'app-auth',
  imports: [ConfigurationComponent, RouterModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <router-outlet></router-outlet>
    <app-configuration></app-configuration>
  `
})
export class AuthComponent {}
